

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class Translation {

    public static translate(text:string):string {
        return NolimitApplication.apiPlugin.translations.translate(text);
    }
}